import { useGLTF } from '@react-three/drei';
import { useRef } from 'react';
import { Mesh } from 'three';


export function Cars({ direction, ust_images, alt_images }) {
  const { scene } = useGLTF("/models/car.glb");
  const carsRef = useRef < Mesh > (null);

  // Define positions for cars stopped at the crosswalk
  const carPositions = direction === 'forward'
    ? [
      { x: 10, z: 2.5 }, { x: 10, z: 7.5 }, { x: 20, z: 2.5 }, { x: 20, z: 7.5 }, { x: 30, z: 2.5 }, { x: 30, z: 7.5 }, { x: 40, z: 2.5 }, { x: 40, z: 7.5 }
    ].slice(0, ust_images.length)  // Üst şeritteki araç sayısını sınırla
    : [
      { x: -10, z: -2.5 }, { x: -10, z: -7.5 }, { x: -20, z: -2.5 }, { x: -20, z: -7.5 }, { x: -30, z: -2.5 }, { x: -30, z: -7.5 }, { x: -40, z: -2.5 }, { x: -40, z: -7.5 }
    ].slice(0, alt_images.length); // Alt şeritteki araç sayısını sınırla

  const rotation = direction === "forward" ? -Math.PI / 2 : Math.PI / 2;

  // Clone the scene once and reuse it
  const carModel = scene.clone();

  return (
    <group>
      {carPositions.map((pos, i) => (
        <group
          key={i}
          position={[pos.x, 0, pos.z]}
          rotation={[0, rotation, 0]}
        >
          <primitive
            object={carModel.clone()}
            scale={[1.5, 1.5, 1.5]}
            castShadow
            receiveShadow
          />
        </group>
      ))}
    </group>
  );
}

// Preload the model to prevent loading delays
useGLTF.preload("/models/car.glb");